import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IaithApiService } from './iaith-api.service';
import { StorfaDefnyddiwrService } from '../system/storfa-defnyddiwr.service';

@Injectable({
    providedIn: 'root'
})
export class IaithSystemService implements TranslateLoader {

    constructor(private iaithApiService: IaithApiService, private storfaDefnyddiwrService: StorfaDefnyddiwrService) { }

    getTranslation(lang: string): Observable<any> {

        const proffil = this.storfaDefnyddiwrService.nolProffil();

        if (!proffil) {
            return of('dim-iaith');
        }

        if (lang === environment.iaith.saesneg) {
            return this.iaithApiService.get(environment.iaith.rhifIaithSaesneg);
        }

        return this.iaithApiService.get(environment.iaith.rhifIaithCymraeg);
    }
}
